<template>
<div class="flex flex-wrap justify-center">
  <div v-for="category in categories" :key="category.category_id_token">
    <CategoryCard :category="category" class="mr-5"/>
  </div>
</div>

</template>

<script>
import { mapActions } from 'vuex'
import CategoryCard from '../common/CategoryCard'

export default {
  components: {CategoryCard},
  
    created() {
    this.handleFetchTopCategories()
    },

    data() {
      return {
        categories: []
      }
    },

    methods: {
          ...mapActions (['fetchTop9Category']),
      async handleFetchTopCategories() {
         const data = await this.fetchTop9Category();
       if(data.result) {
        this.categories = data.categories;
      }
      }
    }
}
</script>